<template>
    <!--begin::Dashboard-->
    <div class="row">
        <div
            class="col-12 aos-init aos-animate content mx-auto"
            :class="totalSumm !== 0 ? 'mb-50' : ''"
            data-aos="fade-up"
            data-aos-delay="100"
        >
            <div class="titulo-pagina mb-10 text-lg-left text-sm-center">
                <span>PERFIL DE </span><span class="text-uppercase">{{client.codigoRol}}</span>
            </div>
            <div class="card-femsa d-none d-sm-block">
                <div
                    class="card-body row justify-content-between align-items-center py-6 px-8"
                >
                    <div class="col-4 col-lg-4 d-none d-sm-block">
                        <div class="card-femsa-titulo">NOMBRE EMPRESA</div>
                        <div class="card-femsa-sub-titulo mt-4">
                            {{ client.nombreEmpresa }}
                        </div>
                    </div>
                    <div class="col-4 col-lg-2 d-none d-sm-block">
                        <div class="card-femsa-titulo">RUT EMPRESA</div>
                        <div class="card-femsa-sub-titulo mt-4">
                            {{ client.rutEmpresa }}-{{ client.rutEmpresaDv }}
                        </div>
                    </div>
                    <div class="col-12 col-lg-3 mt-5 mt-lg-0 d-none d-sm-block">
                        <div class="card-femsa-titulo">CORREO CORPORATIVO</div>
                        <div class="card-femsa-sub-titulo mt-4">
                            {{ client.email }}
                        </div>
                    </div>

                    <div class="col-12 col-lg-3 mt-5 mt-lg-0 total-deuda">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-6 border-right">
                                <div class="total-deuda-titulo text-uppercase font-weight-normal fs-15">TOTAL A PAGAR</div>
                                <div class="total-deuda-monto mt-1 fs-15">
                                   {{order.monto | currency}}
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-6">
                                <div class="total-deuda-titulo text-uppercase font-weight-normal fs-15 d-flex justify-content-center">Saldo disponible <img class="info-Img" src="/media/img/infoImg.png" data-toggle="tooltip" title="Este saldo representa el dinero real que tienes a tu disposición para gastar o retirar en un momento específico."></div>
                                <div class="total-deuda-monto mt-1 fs-15">
                                    {{ saldoDisponible | currency }}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-block d-sm-none total-deuda">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-6 border-right">
                        <div class="total-deuda-titulo text-uppercase font-weight-normal fs-15">TOTAL A PAGAR</div>
                        <div class="total-deuda-monto mt-1 fs-15">
                            {{ deudaTotal | currency }}
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6">
                        <div class="total-deuda-titulo text-uppercase font-weight-normal fs-15 d-flex justify-content-center">Saldo disponible <img class="info-Img" src="/media/img/infoImg.png" data-toggle="tooltip" title="Este saldo representa el dinero real que tienes a tu disposición para gastar o retirar en un momento específico."></div>
                        <div class="total-deuda-monto mt-1 fs-15">
                            {{order.monto | currency}}
                            
                        </div>
                    </div>
                </div>
            </div>

            

            
            <b-overlay :show="enviando" varant="white" rounded="sm">
                <template>
               <div class="container">
                    <div class="titulo-pagina mb-10 text-lg-left text-sm-center text-uppercase my-4">
                        <span>Métodos</span><span> DE PAGO</span>
                    </div>
                    <div class="card-femsa-titulo my-4">¿Cómo quieres pagar?</div>
                    <div class="card-femsa-sub-titulo my-4">¡Recuerda que puedes pagar con tu saldo disponible!</div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="card-femsa">
                                <div class="card-body">
                                    <div class="card-femsa-titulo mb-3" v-if="saldoDisponible > 0">Paga con tú saldo</div>
                                    <div class="card-femsa-sub-titulo mb-4" v-if="saldoDisponible > 0">Tú saldo disponible al {{order.fechaCreacion | formatDate}}</div>
                                    <div class="card-femsa-titulo h3 font-weight-bold mb-4" v-if="saldoDisponible > 0"> {{ saldoDisponible | currency }}</div>
                                    <div class="modulo-pago-disponible mb- d-flex" v-if="saldoDisponible > 0">
                                        <input class="custom-checkbox mb-3 mr-2" type="radio" @click="updateSaldoUtilizado" name="tipoPago" id="cbox1"/>
                                        <label for="cbox1"><span class="card-femsa-sub-titulo d-flex">Pagar con saldo total</span></label>
                                    </div>
                                    <div class="modulo-content-pago-abono" v-if="saldoDisponible > 0">
                                        <input class="custom-checkbox mb-3 mr-2" type="radio" @click="saldoUtilizado=0" name="tipoPago" id="cbox2"/>
                                        <label for="cbox2"><span class="d-flex card-femsa-sub-titulo">Pagar con saldo disponible</span></label>
                                        <div class="col-sm-12 col-md-12 pl-0">
                                            <money  v-bind="money" 
                                                id="example-input-1"
                                                min=1 :max="order.monto"
                                                name="example-input-1"
                                                v-model="saldoUtilizado"
                                                 @change="updateSaldoUtilizar"
                                                aria-describedby="input-1-live-feedback" autofocus
                                                class="form-control form-control-femsa"></money>
                                           
                                        </div>
                                    </div>
                                    <div v-if="totalSumm > 0" class="card-femsa-titulo mt-5 mb-4">Elige tú banco</div>
                                    <ul v-if="totalSumm > 0" class="list-group list-group-flush">

                                        <li class="list-group-item pl-0" v-for="method in methods" v-bind:key="method.codigo">
                                            <div class="row">
                                            <div class="col-10">
                                                    <label class="d-flex"><input name="medio" class="custom-checkbox mr-2" @change="onUpdatePay(method.codigo)" type="radio" id="cbox1" value="first_checkbox"/>
                                                    <span class="card-femsa-sub-titulo">{{method.nombre}}</span></label>
                                                </div>
                                                <div class="d-none d-md-block col-2 justify-content-end">
                                                    <div class="modulo-image">
                                                        <img :src="`/media/img/banco-${method.codigo}.png`">
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </li>
                                        
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <!-- Card Resumen de pago -->
                        <div class="col-sm-12 col-md-6 col-lg-6">
                            <div class="card-femsa mt-3 mt-md-0 mt-lg-0">
                                <div class="card-body">
                                    <div class="card-femsa-titulo mb-4 mb-4">Resumen de pago</div>
                                    <div class="row">
                                        <div class="col-6">
                                            <span class="card-femsa-sub-titulo">Total a Pagar</span>
                                        </div>
                                        <div class="col-6 d-flex justify-content-end">
                                            <div class="modulo-total-pago">
                                                <p class="card-femsa-sub-titulo font-weight-bold">{{order.monto | currency}}</p>
                                            </div>
                                            
                                        </div>
                                        <div class="col-6">
                                            <span class="card-femsa-sub-titulo">Descuento saldo disponible</span>
                                        </div>
                                        <div class="col-6 d-flex justify-content-end">
                                            <div class="modulo-total-disponible">
                                                <span class="card-femsa-sub-titulo font-weight-bold">- {{saldoUtilizado|currency}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modulo-total-pago mt-5 border-top pt-4">
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="modulo-total-monto card-femsa-titulo">
                                                    <h5 class="font-weight-bold">Total</h5>
                                                </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="modulo-total-monto d-flex justify-content-end card-femsa-titulo">
                                                        <h5 class="font-weight-bold">{{totalSumm|currency}}</h5>
                                                    </div>
                                                </div>
                                        </div>
                                            
                                    </div>
                                </div>
                                
                                    <div class="row">
                                        <div class="col-12 col-md-6 col-lg-6">
                                            <button v-on:click.prevent="updateOrder()"
                                                :disabled="totalSumm < 0" class="button-18 w-100 btn-second-femsa" role="button">Pagar</button>
                                        </div>
                                        <div class="col-12 col-md-6 col-lg-6">
                                           <button @click="cancelar()" class="button-18 w-100 btn-outline-femsa mt-3 mt-md-0 mt-lg-0" role="button">cancelar</button>
                                        </div>
                                    </div>
                                
                            </div>
                        </div>

                    </div>
                </div> 
				</template>
            </b-overlay>
        </div>
        <div
            class="contenedor-medios-de-pago d-flex flex-column justify-content-center"
        >
            <form
                id="irapagar"
                name="irapagar"
                method="post"
                :action="orden.payUrl"
            >
                <input
                    type="hidden"
                    name="guidTransaccion"
                    :value="orden.guidTransaccion"
                />
                <input
                    type="hidden"
                    name="idEntidadRecaudadora"
                    :value="orden.idEntidad"
                />
                <input
                    type="hidden"
                    name="codigoAplicacion"
                    :value="orden.codigoAplicacion"
                />
                <input type="hidden" name="rutCliente" :value="rutCliente" />
                <input type="hidden" name="monto" :value="orden.monto" />
            </form>
           
        </div>
    </div>

    <!--end::Dashboard-->
</template>

<script>
import { mapState } from "vuex";
import { GET_DOCUMENTS, GET_BALANCES } from "@/core/services/store/client.module";
import {
    GET_METHODS,
    GET_ORDER_TOKEN,
    UPDATE_ORDER
} from "@/core/services/store/payment.module";
//import VueAos from 'vue-aos'
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { minLength } from "vuelidate/lib/validators";
import {Money} from 'v-money'
import moment from "moment";
moment.locale("es");
const notaCredito = "CM";
export default {
    mixins: [validationMixin],
    name: "dashboard",
    components: { Money },
    data() {
        return {
            enviando: false,
            page: 1,
            perPage: 9999999999,
            selected: [],
            loading: true,
            menu2: false,
            menu1: false,
            hasta: null,
            desde: null,
            orden: {},
            sucursal: "",
            codigoMedioPago: "",
            form: {
                documento: "",
                desde: "",
                hasta: "",
            },
            deudaTotal: 0,
            saldoDisponible:0,
            saldoUtilizado : 0,
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "$ ",
                suffix: "",
                precision: 0,
                masked: false,
            },

            json_fields: {
                Documento: "numeroDocumento",
                Monto: "monto",
                Abonado: "abonado",
                Saldo: "saldo",
                Sucursal: "sucursal",
                Vencimiento: "fechaVencimiento",
            },
        };
    },
    async mounted() {
        await this.getOrder();
        this.getBalances();
        this.getMethods();
    },
    validations: {
        form: {
            documento: {
                minLength: minLength(3),
            },
            desde: {},
            hasta: {},
        },
        documents: {
            $each: {
                saldo: {
                    required,
                    maxespecial: function (misaldo, item) {
                        if (item.codigoTipoDocumento != notaCredito)
                            return (
                                (misaldo <= item.deuda && misaldo > 0) ||
                                !item.seleccionado
                            );
                        else
                            return (
                                (misaldo >= item.deuda && misaldo < 0) ||
                                !item.seleccionado
                            );
                    },
                },
                monto: { required },
                abonado: required,
                sucursal: required,
                permiteAbonar: required,
                numeroDocumento: required,
                seleccionado: required,
            },
        },
    },
    methods: {
        cancelar() {
            console.log('xxx');
            this.$router.push({ name: "dashboard"});
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        resetForm() {
            this.form = {
                documento: null,
                sucursal: null,
                desde: null,
                hasta: null,
            };

            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        onSubmit() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }

            const documento = this.$v.form.documento.$model;
            const sucursal = this.sucursal;
            const desde = this.desde;
            const hasta = this.hasta;

            // set spinner to submit button
            const submitButton = this.$refs["kt_login_signin_submit"];
            submitButton.classList.add(
                "spinner",
                "spinner-light",
                "spinner-right"
            );
            // dummy delay
            setTimeout(() => {
                // send login request
                this.getDocuments({
                    params: { documento, sucursal, desde, hasta },
                });
                submitButton.classList.remove(
                    "spinner",
                    "spinner-light",
                    "spinner-right"
                );
            }, 500);
        },
        getDocuments(params = null) {
            this.$Progress.start();
            this.$store
                .dispatch(GET_DOCUMENTS, params)
                .then((response) => {
                    (this.deudaTotal = response.totalDeuda),
                        this.$Progress.finish(),
                        (this.loading = false);
                })
                .catch(function () {
                    this.$Progress.finish(), (this.loading = false);
                });
        },
        getBalances(params = null) {
            this.$Progress.start();
            this.$store
                .dispatch(GET_BALANCES, params)
                .then((response) => {
                    (this.saldoDisponible = response.totalSaldoAFavor),
                        this.$Progress.finish(),
                        (this.loading = false);
                })
                .catch(function () {
                    this.$Progress.finish(), (this.loading = false);
                });
        },
        getMethods() {
            this.$Progress.start();
            this.$store.dispatch(GET_METHODS).then(() => {
                this.$Progress.finish();
            });
        },
        async getOrder() {
            this.$Progress.start();
            await this.$store
            .dispatch(GET_ORDER_TOKEN, this.$route.params.codigo)
            .then(()=>{this.$Progress.finish()});
        },
        updateOrder() {

            this.$v.documents.$touch();
            if(this.saldoUtilizado > this.order.monto) {
                Swal.fire({
                    title: "",
                    text: "El monto de pago no puede ser negativo",
                    icon: "error",
                    confirmButtonClass: "btn btn-secondary"
                });
                return;
            }
            if(this.totalSumm > 0 && this.codigoMedioPago=='') {
                Swal.fire({
                    title: "",
                    text: "Debes seleccionar un medio de pago",
                    icon: "error",
                    confirmButtonClass: "btn btn-secondary"
                });
                return;
            }
            const t = this;
            this.order.documents = this.documents;
            this.order.saldoDisponible = this.saldoDisponible;
            this.order.codigoMedioPago = this.codigoMedioPago;
            this.order.tipoOrden = 0;
            this.order.montoSaldoRecibos = parseFloat(this.saldoUtilizado);
            this.enviando = true;
            this.$store
                .dispatch(UPDATE_ORDER, this.order)
                .then(function (response) {
                    t.orden = response;
                    if(response.payUrl.indexOf("#")>0){
                        location.href=response.payUrl;
                    } else {
                        if (response.nuevaVentana) {
                            var left = screen.width / 2 - 800 / 2;
                            var top = screen.height / 2 - 600 / 2;
                            window.open(
                                "",
                                "formpopup",
                                "width=800,height=600,resizeable,scrollbars, top=" +
                                    top +
                                    ", left=" +
                                    left
                            );       
                            document.getElementById("irapagar").target =
                                "formpopup";                 
                        }
                        setTimeout(()=>{
                            document.getElementById("irapagar").submit();
                                
                            },0);
                    }
                }).catch(()=>{
                   this.enviando = false;
                    Swal.fire({
                        title: "",
                        text: "Error al iniciar el proceso de pago. Por favor intente nuevamente",
                        icon: "error",
                        confirmButtonClass: "btn btn-secondary"
                    });
                });
        },
        onUpdatePay(activePay) {
            this.codigoMedioPago = activePay;
        },
        updateSaldoUtilizado() {
            this.saldoUtilizado = JSON.stringify(this.saldoDisponible);
            if(this.saldoDisponible > this.order.monto)
                this.saldoUtilizado = JSON.stringify(this.order.monto);
        },
        updateSaldoUtilizar() {
            if(this.saldoUtilizado > this.order.monto)
                this.saldoUtilizado = JSON.stringify(this.order.monto);
            console.log(this.saldoUtilizado + ' NUEVO ' + this.order.monto);
        },
        estiloItem(item) {
            const hoy = new Date();
            var date1 = moment(hoy).format("YYYY-MM-DD");
            var date2 = moment(item.fechaVencimiento).format("YYYY-MM-DD");
            if (moment(date1).isBefore(date2)) {
                return "no-vencida";
            } else {
                return "vencida";
            }
        },
    },
    filters: {
        formatDate(value) {
            const duration = moment(value).format("DD/MM/yyyy");
            return `${duration}`;
        },

        formatTime(value) {
            const hora = moment(value).format("HH:mm:ss");
            return `${hora}`;
        },
    },
    computed: {
        ...mapState({
            documents: (state) => state.client.documents,
            balances: (state) => state.client.balances,
            sucursales: (state) => state.client.branchs,
            methods: (state) => state.payment.methods,
            order: (state) => state.payment.order,
            errors: (state) => state.errors,
            client: (state) => state.auth.user,
            totalSumm: function () {
                if(this.saldoUtilizado>this.saldoDisponible)
                    this.saldoUtilizado = this.saldoDisponible;
                return this.order.monto - this.saldoUtilizado;
                /*return this.documents
                    .filter((item) => item.seleccionado)
                    .reduce(function (total, item) {
                        return total + item.saldo;
                    }, 0);*/
            },
            totalDeuda2: function () {
                return this.documents.reduce(function (total, item) {
                    return total + (item.monto - item.abonado);
                }, 0);
            },
            rutCliente: function () {
                return `${this.order.rutEmpresa}-${this.order.dvEmpresa}`;
            },
            computedDateFormattedMomentjs() {
                return this.desde
                    ? moment(this.desde).format("DD/MM/yyyy")
                    : "";
            },
            computedDateFormattedMomentjs2() {
                return this.hasta
                    ? moment(this.hasta).format("DD/MM/yyyy")
                    : "";
            },
        }),
    },
};
</script>
<style>
.custom-checkbox label {
    margin-top: 5px;
    display: block;
}
.custom-control-label::before {
    position: absolute;
    top: 0rem !important;
}
.custom-control-label::after {
    top: 0rem !important;
}
.b-form-datepicker {
    min-width: 130px;
}
.b-form-datepicker label {
    padding-bottom: 3px !important;
    padding-top: 6px;
    text-transform: none;
    white-space: nowrap !important;
    font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 10px 5px;
}
.d-content-full {
    width: 100%;
}
@keyframes float {
    0% {
        box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
        transform: translatey(0px);
    }
    50% {
        box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);
        transform: translatey(-20px);
    }
    100% {
        box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
        transform: translatey(0px);
    }
}
._levitar {
    margin-top: 20px;
    animation: float 6s ease-in-out infinite;
}
.download {
    cursor: pointer;
    text-align: right;
    margin-right: 10px;
    display: table-cell;
    float: right !important;
}
.document {
    width: 80px;
}
.document-type {
    width: 90px;
}
.expired {
    width: 110px;
}
.branch {
    width: 110px;
}
.ammount {
    width: 105px;
}
.payment {
    width: 105px;
}
.input-payment {
    width: 170px;
}
.error {
    color: Red;
    font-size: 0.65em;
}
.custom-checkbox{
    width: 20px;
    height: 20px;
}
label {
    display: inline-block!important;
    margin-bottom: 0.5rem!important;
}
</style>
